/**
 * getLabelById finds and returns a sensitivity label info that matches the provided Id.
 * @param labels The array of labels to search from
 * @param id The id of the label we want to retrieve
 */
export function getLabelById(labels, id) {
    const filteredLabels = labels.filter((value) => value.id === id);
    // TODO: Log error if we retrieve multiple labels with same Id
    if (filteredLabels.length === 1) {
        return filteredLabels[0];
    }
    else {
        return undefined;
    }
}
//# sourceMappingURL=getLabelById.js.map